import * as React from 'react';
import {useEffect, useState} from "react";
import {getLegacyDocument} from "../../api";
import {useParams} from "react-router-dom";
import {LegacyDocument} from "../../types";


const Export: React.FunctionComponent = () => {

    const {documentId} = useParams();
    const [document, setDocument] = useState<LegacyDocument>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (documentId !== undefined) {
            setLoading(true);
            getLegacyDocument(documentId)
                .then((ld) => {
                    setDocument(ld);
                })
                .finally(() => setLoading(false))
        }
    }, []);

    return ((loading) ? <>...Loading document...</> : <>
        {
            document?.pages.map((p) => (
                <div key={"p_" + p.number} style={{border: '1px solid #000', marginBottom: 20}}>
                <div  className={"document-wrapper"}
                     style={{position: "relative", width: p.width, height: p.height}}>
                    {
                        p.fields.map((f) => (
                            <div key={"f_" + f.id}
                                 style={{fontSize: 12, position: "absolute", top: f.y, left: f.x}}>
                                {(f.value !== undefined && f.value.startsWith("data:image")) ?
                                    <img src={f.value}/>
                                    : f.value}
                            </div>
                        ))
                    }

                    <img src={p.imageData} width={p.width} height={p.height}/>
                </div>
                </div>
            ))
        }

    </>);
};

export default Export;

